import React, {useEffect, useState} from 'react';
import {Tabs} from 'antd';
import {withRouter} from 'react-router-dom';
import CommToolContext from '../../common/comm_tool_context';
import {
  getFMPProject,
  getIpsTeamRoleMembers,
  getTrackersByDiscipline,
  getLCARACTStatus,
  saveTrackerTrackAudit,
  updateFMPProjectDetails
} from '../../../api';
import ProjectTabRoutes from '../../../components/ProjectTabsList/ProjectTabRoutes';
import IPSAsset from '../Asset/IpsAssetRemoval';
import IPSProjectTeam from '../ipsproject_team';
import FMPTrackerTabContainer from './FMPTrackerTabContainer';
import AssetReview from "../Asset/AssetReview";
import Accordion from "../../../components/Accordion/Accordion"
import IpsWorkCompleteSection from "./IpsWorkCompleteSection/IpsWorkCompleteSection";

const {TabPane} = Tabs;

function FMPTrackersTabs(props) {
  // TODO remove this or leave for whoever will create the container 
  const {
    project,
    context,
    history,
    match,
    status,
    teamMembersList,
    allDropDownOptions,
  } = props;

  const {setActiveProject} = context;
  const [fmpTracks, setFmpTracks] = useState([])
  const [lcrarcStatus, setLCARCAStatus] = useState([]);
  const handleAddAction = async (rowData) => {
    try{
        //const response = await saveTrackerTrackAudit(projectInfo, project,rowData)

    }catch (error){
      console.error('API ERROR on Save: ', error);
    }
  };

  useEffect(() => {
    setActiveProject(project);
  }, []);

  const [teamMembers, setTeamMembers] = useState(teamMembersList);
  const [currentProject, setCurrentProject] = useState(project);
  const currentTabId = match.params.tabId;

  let projectInfo = {
    bpid: project.bpid,
    workOrder: project.workOrder,
    stationName: project.stationName,
    fmpId: project.fmpId
  };
  useEffect(() => {
    if (currentTabId === 'fmptracker' || currentTabId === 'assetreview') {
      const fetchTrackers = async () => {
        let projectInfo = {
          bpid: project.bpid,
          workOrder: project.workOrder,
          stationName: project.stationName,
          fmpId: project.fmpId
        };

        try {
          const lcrarcStatus = await getLCARACTStatus(projectInfo)
          const updatedProjectList = await getFMPProject(projectInfo);
          setFmpTracks(updatedProjectList);
          setLCARCAStatus(lcrarcStatus)
        } catch (error) {
          console.error('Failed to fetch FMP Trackers:', error);
          setFmpTracks([]);
        }
      };
      fetchTrackers();
    } else {
      // Optionally clear the tracker data if switching to a non-tracker tab
      setFmpTracks([]);
    }
    // This dependency array ensures it runs when the URL/tab ID changes, including on refresh.
  }, [currentTabId, project.bpid, project.workOrder, project.stationName]);

  async function developTabsOnclick(key) {
    switch (key) {
      case 'details':
        const teamMembers = getIpsTeamRoleMembers(projectInfo);

        const updatedProjectList = getFMPProject(projectInfo);
        let result = await Promise.allSettled([teamMembers, updatedProjectList]);

        setTeamMembers(result[0].value);
        setCurrentProject(result[1].value);
        setActiveProject(result[1].value);

        break;
      case 'fmptracker':
        try {
          setFmpTracks([])
          const updatedProjectList = await getFMPProject(projectInfo); 
          setFmpTracks(updatedProjectList);
        } catch (error) {
          console.error('Failed to fetch FMP Trackers:', error);
        }
        break;
      default:
    }
  }

  async function handleProjectDetailUpdate (
    value,
    fieldName,
    dataType,
    fmpId,
    statusAction,
    auditId
  )  {
    let field = {};
    field['bpid'] = project.bpid;
    field['workOrder'] = project.workOrder;
    field['stationName'] = project.stationName;
    field['dataField'] = fieldName;
    field['fmpId'] = fmpId;
    field['statusAction'] = statusAction===null? 'A':statusAction;
    field['auditId'] = auditId;

    if (dataType === 'string') {
      field['charValue'] = value;
    } else if (dataType === 'number') {
      field['numValue'] = value;
    } else if (dataType === 'date') {
      field['dateValue'] = value;
    }
    const response = await updateFMPProjectDetails(field);

    // checking if response value is present incase of failure it keep last state value instead of update project value with empty array
    if (response?.bpid) {
      
      setCurrentProject(response)
    }
    // we are only using response in ipsWorkComplete Section for redirecting user
    return response;
  };

  const getFmpUpdateProject = async() =>{
     const latestData = await getFMPProject(projectInfo);
     setFmpTracks(latestData)
  };

  return (
    <CommToolContext.Consumer>
      {(context) => (
        <div className='container-fluid'>
          <ProjectTabRoutes
            project={project}
            context={context}
            status={status}
          />
          <h4>
            <b>{project.stationName}</b>
          </h4>
          <Tabs
            defaultActiveKey='details'
            className='nav-B'
            onChange={developTabsOnclick}
            onTabClick={(key) => {
              let encodedStationName = encodeURIComponent(project.stationName)
              history.push({
                pathname: `/${status}/${encodedStationName}/${project.bpid}/${project.workOrder}/${key}`,

              })
            }}
            type='card'
            activeKey={match.params.tabId || 'details'}
          >
            <TabPane tab='Project Details' key='details'>
              <FMPTrackerTabContainer
                project={currentProject}
                setCurrentProject={setCurrentProject}
                status={status}
                allDropDownOptions={allDropDownOptions}
                context={context}
                history={history}
                teamMembers={teamMembers}
                // allComments={allComments}
                handleProjectDetailUpdate={handleProjectDetailUpdate}
              />
            </TabPane>
            <TabPane tab='FMP Tracker' key='fmptracker'>
              <Accordion
                data={fmpTracks}
                lcraStatus={lcrarcStatus}
                activeTab='fmp-tracker'
                onRowExpand={(rowId, isExpanded) => {
                }}
                onGroupExpand={(groupName, isExpanded) => {
                }}
                onAddClick={handleAddAction}
                handleProjectDetailUpdate={handleProjectDetailUpdate}
                onDataRefreshed={getFmpUpdateProject}
              />
            </TabPane>
            <TabPane tab='Asset Review' key='assetreview'>
              <AssetReview
                tracksData={fmpTracks}
                project={currentProject}
                lcraStatus={lcrarcStatus}
                onAddClick={handleAddAction}
                handleProjectDetailUpdate={handleProjectDetailUpdate}
                activeTab='asset'
                onDataRefreshed={getFmpUpdateProject}/>
              <IpsWorkCompleteSection
                project={currentProject}
                history={history}
                context={context}
              />
            </TabPane>
            <TabPane tab='Team' key='team'>
              <IPSProjectTeam
                project={currentProject}
                context={context}
                status={status}
              />
            </TabPane>
          </Tabs>
        </div>
      )}
    </CommToolContext.Consumer>
  );
}

// DataTrackersTabs.contextType = DataTrackersTabs;
export default withRouter(FMPTrackersTabs);